export const highlightBrowserLog = (name = '', ...args: any[]) => {
  console.log.apply(console, [
    `%c 🥩 ${name} `,
    'font-size: 14px;padding: 4px 10px;color:blue;background:white',
    ...args,
  ])
}
